<template>
  <div>
    <q-btn
      outline
      dense
      class="text-blue-9 q-px-sm q-my-sm"
      size="sm"
      v-if="hasImage"
      @click="showImageDialog = true"
    >
      <q-icon name="fas fa-image" size="13px" class="q-mr-sm" />
      <span>查看备注图片</span>
    </q-btn>

    <q-dialog v-if="hasImage" v-model="showImageDialog">
      <q-card>
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">图片备注信息</div>
          <q-space />
          <q-btn icon="fas fa-times" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section>
          以下是关于 样本{{ sample.detail.name }} 的备注图片信息。<br />
          共计
          {{ sample.detail.member_attachment_urls.length }}
          张图片。<br /><br />

          <q-img
            v-for="image_url in sample.detail.member_attachment_urls"
            :key="image_url"
            :src="image_url"
            style="max-width: 400px; height: 200px"
            contain
          >
          </q-img>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showImageDialog: false,
    };
  },

  props: {
    sample: {
      type: Object,
      default: {},
    },
    hasImage: {
      type: Boolean,
      default: {},
    },
  },
};
</script>
